export function index()
{
    return axios.get(route('api.manage.share-job.index'))
        .then(({data}) => data);

};

export function getFavorites()
{
    return axios.get(route('api.manage.share-job.favorite.show'))
        .then(({data}) => data);

}

export function storeFavorites(shareJobCardId) 
{
    return axios.post(route('api.manage.share-job.favorite.store', {shareJobCardId}))
        .then(({data}) => data);
}

export function deleteFavorites(shareJobCardId)
{
    return axios.delete(route('api.manage.share-job.favorite.destroy', {shareJobCardId}))
        .then(({data}) => data);

}